import DynamicFieldButtons from '../dynamic-field-multiple/DynamicFieldButtons'
import DynamicFieldMultiple from '../dynamic-field-multiple/DynamicFieldMultiple'
import AttrDisplayProps from './AttrDisplayProps'
import classes from './AttrDisplayList.module.scss'
import clsx from 'clsx'
import numeral from 'numeral'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectSkipCoDecisioning } from '../../../../../../features/createCertificate/createCertificateSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle, faSearch } from '@fortawesome/free-solid-svg-icons'
import { Tooltip } from 'primereact/tooltip'
import { Button } from 'primereact/button'
import CertificateCustomerNameLookup from '../../certificate-customer-name-lookup/CertificateCustomerNameLookup'

export type AttrDisplayListProps = {
  addDynamicField: any
  isEditCert: any
  isModifyCert: any
  hasRevisions: any
  onAddDynamicFieldMultiple: any
  onRemoveDynamicFieldMultiple: any
  certifyFields: Array<string>
  decisionFields: Array<string>
  recommendFields: Array<string>
  validityMessage: any
  isFieldMounted: any
  setIsFieldMounted: any
  onCopyDynamicFieldMultiple: any
  closeLookupSignal: any
} & AttrDisplayProps
export default function AttrDisplayList({
  attrDisplay,
  attrIndex,
  attributeFlatList,
  certGroupIndex,
  formDisplay,
  setFormValidityMessages,
  setFormValues,
  setIsShowNoStandard,
  formValues,
  selectedScheme,
  isShowNoStandard,
  // extended props
  addDynamicField,
  isEditCert,
  isModifyCert,
  hasRevisions,
  onAddDynamicFieldMultiple,
  onRemoveDynamicFieldMultiple,
  certifyFields,
  decisionFields,
  recommendFields,
  validityMessage,
  isFieldMounted,
  setIsFieldMounted,
  fieldChangeListener,
  onCopyDynamicFieldMultiple,
  closeLookupSignal
}: AttrDisplayListProps) {
  const [isLookupShow, setIsLookupShow] = useState(false);
  const [filterListener, setFilterListener] = useState<{
    field: string | null
    value: string | null
    index: number | null
  }>({
    field: null,
    value: null,
    index: null,
  })

  const prefix = `dynamic-field-multiple-${certGroupIndex}-${attrIndex}`
  const firstAttr = attrDisplay.attribute[0]
  const helperText = attrDisplay.attribute[0].help_text
  const value = formValues[firstAttr.attribute_unique_name]

  const isValueArray = Array.isArray(value)
  const maxValue = numeral(firstAttr.max_value).value()
  const [cacheValues, setCacheValues] = useState<null | {
    [key: string]: any
  }>(null)
  const skipCoDecisioning = useSelector(selectSkipCoDecisioning)
  const listDecisionAttributes = decisionFields

  const isDropdownMultiple =
    isValueArray &&
    firstAttr.is_allow_search &&
    ((maxValue ?? 0) > 0 || firstAttr.max_value === 'n')

  const hasValue = isValueArray ? value.length > 0 && value.every(Boolean) : Boolean(value)
  const attributes = (attrDisplay?.attribute as any[]) ?? []

  const isButtonDisabled = () => {
    if (firstAttr) {
      const isCoFieldDisabled =
        skipCoDecisioning && listDecisionAttributes.includes(firstAttr.attribute_unique_name)
      return isCoFieldDisabled
    }
    return false
  }

  const handleSearchCustomer = () => {
    const listenerField = firstAttr.attribute_unique_name
    const index = formValues[listenerField]?.length > 0 ? formValues[listenerField]?.length - 1 : 0

    setFilterListener({ field: listenerField, value: null, index: index })
    setIsLookupShow(true)
  }
  return (
    <>
      <div className={clsx('dynamic-fld-card', classes['attr-display-list'])}>
        <div className="ul-grid__row dynamic-fld-card-grid-row">
          <div className="ul-grid__column -x80 dynamic-fld-card-hdr">
            <span>{firstAttr['display_name']} </span>
            {firstAttr.is_required && <span className="text-red"> *</span>}
            {firstAttr?.help_text != '' && (
              <span className={`tooltip-target-dynamic-${firstAttr.attribute_unique_name}`}>
                <FontAwesomeIcon
                  className={`${classes['tooltip-icon']}`}
                  icon={faQuestionCircle}
                  size="xs"
                />

                <Tooltip
                  target={`.tooltip-target-dynamic-${firstAttr.attribute_unique_name}`}
                  position="right"
                >
                  {helperText}
                </Tooltip>
              </span>
            )}

            {firstAttr.is_allow_search && (
              <span className={classes['cl-container']} onClick={handleSearchCustomer}>
                <FontAwesomeIcon className={`${classes['tooltip-icon']}`} icon={faSearch} size="xs" />
                <Button className={clsx(classes['cl-search-btn'], 'p-button-link')}>
                  <span>Search</span>
                </Button>
              </span>
            )}
          </div>
          <div className="ul-grid__column -x20"></div>
        </div>

        {attributes.map((field, fieldIndex) => {
          const uuid = field.uuid ?? `row-${fieldIndex}`
          const isLastIndex = fieldIndex === attributes.length - 1
          const fieldName = field.attribute_unique_name
          const listener = fieldChangeListener
            ? fieldChangeListener[field.attribute_unique_name]
            : undefined
          return (
            <div
              key={`${prefix}-${fieldIndex}-${field.id}-${uuid}`}
              className="ul-grid__row dynamic-fld-card-grid-row"
            >
              <div
                className="ul-grid__column -x80 dynamic-fld-card-body"
                id={`certDetails-${field.attribute_unique_name}-${fieldIndex}`}
              >
                <DynamicFieldMultiple
                  setIsShowNoStandard={setIsShowNoStandard}
                  selectedScheme={selectedScheme}
                  field={field}
                  isRequired={field.is_required}
                  formValues={formValues}
                  attributeFlatList={attributeFlatList}
                  formDisplay={formDisplay}
                  setFormValues={setFormValues}
                  certGroupIndex={certGroupIndex}
                  setFormValidityMessages={setFormValidityMessages}
                  fieldIndex={fieldIndex}
                  rowIndex={fieldIndex}
                  fieldType={attrDisplay.type}
                  isEditCert={isEditCert}
                  isModifyCert={isModifyCert}
                  hasRevisions={hasRevisions}
                  addDynamicField={addDynamicField}
                  certifyFields={certifyFields}
                  decisionFields={decisionFields}
                  recommendFields={recommendFields}
                  isFieldMounted={isFieldMounted}
                  setIsFieldMounted={setIsFieldMounted}
                  validityMessage={validityMessage}
                  onFieldChange={(value: any) => {
                    setCacheValues(prev => ({
                      ...prev,
                      [uuid]: value,
                    }))

                    if (listener) {
                      listener(value)
                    }
                  }}
                  listCacheValue={cacheValues ? cacheValues[uuid] : undefined}
                  readOnly={!isLastIndex}
                  filterListener={filterListener}
                  setFilterListener={setFilterListener}
                  setCacheValues={setCacheValues}
                />
              </div>
              {field.max_value !== '1' && (
                <DynamicFieldButtons
                  className={clsx('-x20')}
                  setIsShowNoStandard={isShowNoStandard}
                  rowIndex={fieldIndex}
                  rowLength={attrDisplay.attribute.length}
                  onAddDynamicFieldMultiple={() => {
                    if (isButtonDisabled()) return
                    onAddDynamicFieldMultiple(certGroupIndex, attrIndex, [field])
                  }}
                  onRemoveDynamicFieldMultiple={() => {
                    if (isButtonDisabled()) return
                    onRemoveDynamicFieldMultiple(
                      field.attribute_unique_name,
                      certGroupIndex,
                      attrIndex,
                      fieldIndex,
                      [field],
                      field.uuid ?? 0 // first row
                    )
                    setCacheValues(prev => {
                      const copy = structuredClone(prev)
                      if (copy === null) return copy

                      delete copy[uuid]
                      return copy
                    })
                  }}
                  onCopyDynamicFieldValue={() =>
                    onCopyDynamicFieldMultiple(certGroupIndex, attrIndex, [field], fieldIndex)
                  }
                  addButtonClassName={clsx(
                    ((isDropdownMultiple && !hasValue) ||
                      (validityMessage &&
                        typeof validityMessage === 'object' &&
                        validityMessage?.displayOnEffect)) &&
                    'disabled'
                  )}
                  removeButtonClassName={clsx(isDropdownMultiple && isLastIndex && 'd-none')}
                  fieldName={fieldName}
                  certGroupIndex={certGroupIndex}
                />
              )}
            </div>
          )
        })}
      </div>
      <CertificateCustomerNameLookup
        isLookupShow={isLookupShow}
        setIsLookupShow={setIsLookupShow}
        setFormValues={setFormValues}
        formValues={formValues}
        listener={filterListener}
        setListener={setFilterListener}
        closeSignal={closeLookupSignal}
      />
    </>
  )
}
